module.exports = __webpack_public_path__ + "src/assets/img/car_main.f13d89f1.jpg";